export default "__VITE_ASSET__DMhcpng6__"